import { observer } from 'mobx-react-lite'
import { WebMCPProvider } from 'webmcp-react'
import { useWebMcpEnabled } from 'entities/WebMcp/lib/flag'
import { ContactsTools } from 'entities/WebMcp/ui/ContactsTools'
import { NavigationTools } from 'entities/WebMcp/ui/NavigationTools'
import { MessagingTools } from 'entities/WebMcp/ui/MessagingTools'
import { ConversationsTools } from 'entities/WebMcp/ui/ConversationsTools'
import { BroadcastTools } from 'entities/WebMcp/ui/BroadcastTools'
import { AnalyticsTools } from 'entities/WebMcp/ui/AnalyticsTools'

/**
 * Mounts WebMCP tools when the in-app agent flag is on. No-op otherwise.
 * `observer` so the MobX flag hydrating after boot toggles this on.
 */
export const WebMcpProvider = observer(() => {
  const enabled = useWebMcpEnabled()

  if (!enabled) return null

  return (
    <WebMCPProvider name='salesmsg-web' version='0.1.0'>
      <ContactsTools />
      <NavigationTools />
      <MessagingTools />
      <ConversationsTools />
      <BroadcastTools />
      <AnalyticsTools />
    </WebMCPProvider>
  )
})
